import React from "react";
import artiacl1 from "../../Images/new/n1.webp";
import artiacl2 from "../../Images/new/n2.jpeg";
import artiacl3 from "../../Images/new/n3.jpg";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
const Artical = () => {
  return (
    <div>
      <h2 className="lg:text-5xl text-4xl text-accent text-center font-bold mt-10">
        New arrivals our products
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-10">
        <div className="card card-compact w-80 bg-base-100 mx-auto shadow-xl  hover:scale-110 hover:duration-500">
          <figure>
            <img className="h-100" src={artiacl1} alt="Shoes" />
          </figure>
          <div class="card-body text-accent">
            <p className="text-lg text-left text-gray-500">February 4, 2023</p>
            <h2 className="text-lg text-left font-bold">
              XIAOMI Mijia hot water dispenser machine.
            </h2>
            <Link
              to="/product/6575b1d3a79c8fbaee4d3f4c"
              className="text-lx font-bold text-orange-500"
            >
              Read More{"  "}
              <FontAwesomeIcon className="ml-1" icon={faArrowRight} />
            </Link>
          </div>
        </div>
        <div className="card card-compact w-80 bg-base-100 mx-auto shadow-xl hover:scale-110 hover:duration-500">
          <figure>
            <img className="h-100" src={artiacl2} alt="Shoes" />
          </figure>
          <div class="card-body text-accent">
            <p className="text-lg text-left text-gray-500">March 8, 2023</p>
            <h2 className="text-lg text-left font-bold">
              Xiaomi Mijia T100 Mi Smart Electric Toothbrush
            </h2>
            <Link
              to="/product/6575c1f5940f36296fe6304c"
              className="text-lx font-bold text-orange-500"
            >
              Read More{"  "}
              <FontAwesomeIcon className="ml-1" icon={faArrowRight} />
            </Link>
          </div>
        </div>
        <div className="card card-compact w-80 bg-base-100 mx-auto shadow-xl hover:scale-110 hover:duration-500">
          <figure>
            <img className="h-100" src={artiacl3} alt="Shoes" />
          </figure>
          <div class="card-body text-accent">
            <p className="text-lg text-left text-gray-500">April 7, 2023</p>
            <h2 className="text-lg text-left font-bold">
              Xiaomi Youpin Latest 90 NINETYGO Bussiness Suitcase 20 Inch Lock
            </h2>
            <Link
              to="/product/6575c55f940f36296fe6304e"
              className="text-lx font-bold text-orange-500"
            >
              Read More{"  "}
              <FontAwesomeIcon className="ml-1" icon={faArrowRight} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Artical;
